// extracted by mini-css-extract-plugin
module.exports = {"link":"_3gDOc","image":"bz40F","root":"_13zCD"};